module.exports = __webpack_public_path__ + "img/09-min.4e58aadd.jpg";